<template>
    <developStyle></developStyle>
</template>

<script>
import developStyle from "@/components/developing-style";
export default {
    components: {
        developStyle,
    },
};
</script>

<style scoped></style>
